import { useCallback, useState } from 'react';
import Toasts from '../../components/Toasts/Toasts';
import { NewToast, Toast, ToastContext } from './ToastContext';

const AUTO_CLOSE_DURATION = 5000;

export const ToastProvider = ({
  children,
  autoCloseDuration = AUTO_CLOSE_DURATION,
}: {
  children: React.ReactNode;
  autoCloseDuration?: number;
}) => {
  const [toasts, setToasts] = useState<Toast[]>([]);

  const removeToast = (id: string) => {
    setToasts((toasts) => toasts.filter((toast) => toast.id !== id));
  };

  const addToast = useCallback(
    (newToast: NewToast) => {
      const toast = { ...newToast, id: new Date().toISOString() };

      // If the toast is set to clear existing toasts, we clear them first
      setToasts((toasts) => (toast.clearToasts ? [toast] : [...toasts, toast]));

      if (newToast.stick) return;
      setTimeout(() => {
        removeToast(toast.id);
      }, autoCloseDuration);
    },
    [autoCloseDuration]
  );

  return (
    <ToastContext.Provider
      value={{
        toasts,
        addToast,
      }}
    >
      <Toasts toasts={toasts} onClose={removeToast} />
      {children}
    </ToastContext.Provider>
  );
};
